import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background-color: var(--lisa-background);

  .icon{
    width: 13px;
    height: 13px;
  }

  .save-icon{
    width: 15px;
    height: 15px;
    filter: invert(1);
  }
`;


export const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 1rem;
  gap: 15px;
  width: 100%;
  flex-wrap: wrap; 

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 18px;
    border: none;
    border-radius: 2px;
    background-color: var(--dark-blue);
    color: var(--white);
    transition: all 0.2s;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    flex: 1; 
    min-width: 150px;

    &:hover {
      filter: brightness(1.2);
    }

    &.active {
      background-color: var(--white);
      color: var(--dark-blue);
      box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    }
  }

  @media (min-width: 768px) {
    gap: 40px;
    button {
      flex: none;
      min-width: 200px;
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%; 
  gap: 20px;
  margin: 1rem auto; 
  
  @media (min-width: 1024px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const GraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 2px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  overflow: hidden; 

  @media (min-width: 1024px) {
    flex: 1;
    min-width: 30%; 
  }

  .DateFilter {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 2rem;
    align-items: center;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 2px;
    width: 100%;

    .canvas-wrapper {
    position: relative;
    width: 100%;
    max-width: 100%; 
    height: 300px;
    display: flex;
    justify-content: center;
  }

    @media (min-width: 600px) {
      flex-direction: row;
      justify-content: center;
      width: auto;
    }

    div {
      display: flex;
      align-items: center;
    }

    input {
      padding: 5px;
      border: 1px solid #ddd;
      border-radius: 2px;
    }
  }

  canvas {
    max-width: 100% !important;
  }
`;

export const DateFilter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  gap: 25px;
  margin-bottom: 2rem;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 2px;
  min-width: 45%;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;